import { gql } from "@apollo/client";

export const PICKUP_TASK_APPOINTMENT_FIELDS = gql`
  fragment PickupTaskAppointmentFields on PickupTaskAppointmentWithAddressType {
    id
    sequence
    site
    zipcode
    addressLine1
    addressLine2
    country
    state
    city
    quantity
    unit
    appointmentTime
    actualQuantity
    actualUnit
    actualTime
    businessHours
    businessDays
    status
    contactName
    contactPhone
    ext
    channelName
    appointmentNumber
    taskId
    warehouseId
    cooperationWarehouseId
    isFinished
    isAbnormal
    isNewWarehouse
    linkStatus
    photosUrls
    exceptionPhotosUrls
    unloadingTime
    actualPickupTime
    exceptionReasonCode
    unloadingPhotosUrls
    actCompleteTime
    remark
    latitude
    longitude
    hasLinkedPickupOrder
  }
`;

export interface PickupAppointmentType {
  id: string;
  sequence: number;
  site: string;
  zipcode: string;
  addressLine1: string;
  addressLine2?: string;
  country?: string;
  state?: string;
  city?: string;
  quantity: number;
  unit: string;
  appointmentTime: string;
  actualQuantity: number;
  actualUnit: string;
  actualTime: string;
  businessHours: string;
  businessDays: number[];
  status: string;
  contactName: string;
  contactPhone: string;
  ext: string;
  channelName: string;
  appointmentNumber?: string;
  taskId: string;
  warehouseId: string;
  cooperationWarehouseId?: string;
  isFinished: boolean;
  isAbnormal: boolean;
  isNew?: boolean;
  isNewWarehouse: boolean;
  /** 揽收站点 2.0 建联状态(1待上门/2揽收成功待建联/3揽收失败待建联/4已建联/5确认无法建联/6上门中)；null=非灰度或历史存量 */
  linkStatus?: number | null;
  photosUrls?: string[];
  exceptionPhotosUrls?: string[];
  unloadingPhotosUrls?: string[];
  unloadingTime: string;
  actualPickupTime: string;
  exceptionReasonCode: string;
  remark: string;
  latitude?: number | null;
  longitude?: number | null;
  hasLinkedPickupOrder: boolean;
}